export class School {
    id: number;
    schoolName: string;
    center: string;
    route: string;
    phone: string;
    phoneExt: string;
    _5digit: number;
    fax: string;
    _5digit2: number;
    grades: string;
    area: number;
    principal: string;
    streetAddress: string;
    city: string;
    zip: number;
    doegrade1213: string;
    pk: boolean;
    elem: boolean;
    mid: boolean;
    sr: boolean;
    tech: boolean;
    arts: boolean;
    adult: boolean;
    ese: boolean;
    charter: boolean;
    choice: boolean;
    magnet: boolean;
    ib: boolean;
    link: string;
    twoMaps: boolean;
    primaryFunc: string;
    doegrade1112: string;
    enrollmentPrev: number;
    enrollmentCurrent: number;
    title1: boolean;
    bell1: string;
    bell2: string;
    misc1: any;
    gKg: boolean;
    g01: boolean;
    g02: boolean;
    g03: boolean;
    g04: boolean;
    g05: boolean;
    g06: boolean;
    g07: boolean;
    g08: boolean;
    g09: boolean;
    g10: boolean;
    g11: boolean;
    g12: boolean;
    g31: boolean;
    district: string;
    programs: boolean;
    nextYearMap: boolean;
    nextYearTwoMap: boolean;
    mapAddress: string;
    schoolPhotoUrl: string;
    latitude: string; // TODO Do you use string or number type for negative number?
    longitude: string; // TODO Do you use string or number type for negative number?
    prevSchoolName: string;
    doegrade1314: string;
    rssfeedlink: string;
    doegrade1415: string;
    doegrade1516: string;
    doegrade1617: string;
    webScreenShotUrl: string;
    description: string;
    doegrade1718: string;

    constructor() {
        this.id = 0;
        this.schoolName = '';
        this.center = '';
        this.route = '';
        this.phone = '';
        this._5digit = null;
        this.fax = '';
        this._5digit2 = null;
        this.grades = '';
        this.area = null;
        this.principal = '';
        this.streetAddress = '';
        this.city = '';
        this.zip = null;
        this.doegrade1213 = '';
        this.pk = false;
        this.elem = false;
        this.mid = false;
        this.sr = false;
        this.tech = false;
        this.arts = false;
        this.adult = false;
        this.ese = false;
        this.charter = false;
        this.choice = false;
        this.magnet = false;
        this.ib = false;
        this.link = '';
        this.twoMaps = false;
        this.primaryFunc = '';
        this.doegrade1112 = '';
        this.enrollmentPrev = null;
        this.enrollmentCurrent = null;
        this.title1 = false;
        this.bell1 = '';
        this.bell2 = '';
        this.misc1 = '';
        this.gKg = false;
        this.g01 = false;
        this.g02 = false;
        this.g03 = false;
        this.g04 = false;
        this.g05 = false;
        this.g06 = false;
        this.g07 = false;
        this.g08 = false;
        this.g09 = false;
        this.g10 = false;
        this.g11 = false;
        this.g12 = false;
        this.g31 = false;
        this.district = '';
        this.programs = false;
        this.nextYearMap = false;
        this.nextYearTwoMap = false;
        this.mapAddress = '';
        this.schoolPhotoUrl = '';
        this.latitude = '';
        this.longitude = '';
        this.prevSchoolName = '';
        this.doegrade1314 = '';
        this.rssfeedlink = '';
        this.doegrade1415 = '';
        this.doegrade1516 = '';
        this.doegrade1617 = '';
        this.webScreenShotUrl = '';
        this.description = '';
        this.doegrade1718 = '';
    }
}

export const SCHOOL_COLUMNS = [
    // 'id',
    'schoolName',
    'center',
    'route',
    'phone',
    'phoneExt',
    '_5digit',
    'fax',
    '_5digit2',
    'grades',
    'area',
    'principal',
    'streetAddress',
    'city',
    'zip',
    'doegrade1213',
    'pk',
    'elem',
    'mid',
    'sr',
    'tech',
    'arts',
    'adult',
    'ese',
    'charter',
    'choice',
    'magnet',
    'ib',
    'link',
    'twoMaps',
    'primaryFunc',
    'doegrade1112',
    'enrollmentPrev',
    'enrollmentCurrent',
    'title1',
    'bell1',
    'bell2',
    'misc1',
    'gKg',
    'g01',
    'g02',
    'g03',
    'g04',
    'g05',
    'g06',
    'g07',
    'g08',
    'g09',
    'g10',
    'g11',
    'g12',
    'g31',
    'district',
    'programs',
    'nextYearMap',
    'nextYearTwoMap',
    'mapAddress',
    'schoolPhotoUrl',
    'latitude',
    'longitude',
    'prevSchoolName',
    'doegrade1314',
    'rssfeedlink',
    'doegrade1415',
    'doegrade1516',
    'doegrade1617',
    'webScreenShotUrl',
    'description',
    'doegrade1718',

    // 'SchoolName',
    // 'LocationNumber',
    // 'Route',
    // 'Phone',
    // '_5digit',
    // 'Fax',
    // '_5digit2',
    // 'Grades',
    // 'Area',
    // 'Principal',
    // 'StreetAddress',
    // 'City',
    // 'Zip',
    // 'Doegrade1213',
    // 'PK',
    // 'Elem',
    // 'Mid',
    // 'Sr',
    // 'Tech',
    // 'Arts',
    // 'Adult',
    // 'Ese',
    // 'Charter',
    // 'Choice',
    // 'Magnet',
    // 'Ib',
    // 'Link',
    // 'TwoMaps',
    // 'PrimaryFunc',
    // 'Doegrade1112',
    // 'EnrollmentPrev',
    // 'EnrollmentCurrent',
    // 'Title1',
    // 'Bell1',
    // 'Bell2',
    // 'Misc1',
    // 'GKg',
    // 'G01',
    // 'G02',
    // 'G03',
    // 'G04',
    // 'G05',
    // 'G06',
    // 'G07',
    // 'G08',
    // 'G09',
    // 'G10',
    // 'G11',
    // 'G12',
    // 'G31',
    // 'District',
    // 'Programs',
    // 'NextYearMap',
    // 'NextYearTwoMap',
    // 'MapAddress',
    // 'SchoolPhotoUrl',
    // 'Latitude',
    // 'Longitude',
    // 'PrevSchoolName',
    // 'DoeGrade1314',
    // 'Rssfeedlink',
    // 'Doegrade1415',
    // 'Doegrade1516',
    // 'Doegrade1617',
    // 'WebScreenShotUrl',
    // 'Description',
    // 'Doegrade1718',
];

export const SELECTED_COLUMNS = [
    'schoolName',
    'center',
    'route',
    'grades',
    'area',
    'principal',
    'streetAddress',
    'city',
    'zip',
    'pk',
    'elem',
    'mid',
    'sr',
    'tech',
    'arts',
    'adult',
    'ese',
    'charter',
    'choice',
    'magnet',
    'ib',
    'link',
    'title1',
    'prevSchoolName',
    'description',
];